import { Box, Flex, Image, Text, VStack, HStack, Divider, Badge, Icon, ScaleFade } from '@chakra-ui/react'
import React, { useState } from 'react'
import Input from '../Components/Input'
import { AiOutlineFieldNumber } from 'react-icons/ai'
import { FaArrowLeft, FaCheckCircle, FaInfoCircle, FaHistory } from 'react-icons/fa'
import Button from '../Components/Button';
import Seo from '../Utils/Seo';
import METER_DATA from '../Data/LoadEnergyTokens.json';

const MeterIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
        <rect x="4" y="2" width="16" height="20" rx="2" fill="#01022E" />
        <rect x="7" y="5" width="10" height="6" fill="#ECC94B" />
        <path d="M10 8H14" stroke="#CF173C" strokeWidth="2" />
        <circle cx="8" cy="16" r="1.5" fill="white" opacity="0.3" />
        <circle cx="12" cy="16" r="1.5" fill="white" opacity="0.3" />
        <circle cx="16" cy="16" r="1.5" fill="white" opacity="0.3" />
    </Icon>
);

export default function CheckMeter() {
    const [MeterNo, setMeterNo] = useState("");
    const [Loading, setLoading] = useState(false);
    const [Data, setData] = useState(null);
    const [View, setView] = useState("search"); // "search" or "result"
    const [ErrorMSG, setErrorMSG] = useState({
        status: false,
        msg: ""
    });

    const handleBtn = () => {
        setLoading(true);
        setErrorMSG({ status: false, msg: "" });

        // Simulate data lookup
        setTimeout(() => {
            const foundMeter = METER_DATA.find(m => String(m.meterNo).trim() === String(MeterNo).trim());
            if (foundMeter) {
                setData(foundMeter);
                setView("result");
                setLoading(false);
            } else {
                setLoading(false);
                setErrorMSG({
                    status: true,
                    msg: "Meter number not found. Please confirm meter number and try again."
                });
            }
        }, 1200);
    };

    const handleBack = () => {
        setView("search");
        setData(null);
        setMeterNo("");
    };

    const InstructionCard = ({ title, icon, tokens, description, colorScheme = "blue" }) => (
        <VStack
            align="stretch"
            bg="white"
            p={6}
            borderRadius="xl"
            boxShadow="0 10px 30px rgba(0,0,0,0.05)"
            border="1px solid"
            textTransform={"capitalize"}
            borderColor="gray.100"
            spacing={4}
            transition="all 0.3s"
            _hover={{ transform: "translateY(-5px)", boxShadow: "0 15px 35px rgba(0,0,0,0.1)" }}
        >
            <HStack spacing={3}>
                <Box bg={`${colorScheme}.50`} p={3} borderRadius="lg">
                    <Icon as={icon} color={`${colorScheme}.500`} boxSize={5} />
                </Box>
                <Text fontWeight="700" fontSize="lg" color="gray.800">{title}</Text>
            </HStack>
            <Text fontSize="sm" color="gray.600">{description}</Text>
            
            <VStack align="stretch" spacing={3} mt={2}>
                <Box bg="gray.50" p={4} borderRadius="lg" borderLeft="4px solid" borderColor={`${colorScheme}.400`}>
                    <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={1}>KCT 1 (First 20 Digits)</Text>
                    <Text fontFamily="mono" letterSpacing="widest" fontWeight="600" fontSize={["sm", "md"]}>{tokens.kct1}</Text>
                </Box>
                <Box bg="gray.50" p={4} borderRadius="lg" borderLeft="4px solid" borderColor={`${colorScheme}.400`}>
                    <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={1}>KCT 2 (Second 20 Digits)</Text>
                    <Text fontFamily="mono" letterSpacing="widest" fontWeight="600" fontSize={["sm", "md"]}>{tokens.kct2}</Text>
                </Box>
            </VStack>

            <HStack color={`${colorScheme}.600`} fontSize="xs" fontWeight="700" spacing={1}>
                <Icon as={FaInfoCircle} />
                <Text>Enter first 20 digits and press Enter, then enter 2nd 20 digits and press Enter.</Text>
            </HStack>
        </VStack>
    );

    return (
        <Box minH="100vh" bg="#F7FAFC">
            <Seo title='Customer KCT Info' description='EKEDC Customer KCT Info' />
            
            {/* Header */}
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} bg="#01022E" px={"6%"} py="16px" boxShadow="lg">
                <a href='https://ekedp.com/' target='blank'>
                    <Image src='/logo.png' width={"60px"} filter="brightness(1.2)" />
                </a>
            </Box>

            <Flex justifyContent={"center"} p={4} pt={[10, 7]}>
                {View === "search" ? (
                    <ScaleFade initialScale={0.9} in={View === "search"}>
                        <Box 
                            bg="white" 
                            borderRadius="2xl" 
                            p={[6, 10]} 
                            w={["100%", "450px", "550px"]} 
                            boxShadow="2xl"
                            textAlign="center"
                            border="1px solid"
                            borderColor="gray.50"
                        >
                            <Box 
                                w="80px" 
                                h="80px" 
                                bg="blue.50" 
                                borderRadius="full" 
                                display="flex" 
                                alignItems="center" 
                                justifyContent="center" 
                                mx="auto" 
                                mb={6}
                            >
                                <Icon as={MeterIcon} boxSize={10} />
                            </Box>
                            
                            <Text fontSize="20px" fontWeight="800" color="#01022E" mb={2}>KEY CHANGE TO LOAD PURCHASED ENERGY TOKEN</Text>
                            
                            <VStack spacing={6}>
                                <Input 
                                    leftIcon={<AiOutlineFieldNumber />} 
                                    bColor='#F0F2F5' 
                                    iconColor="#01022E" 
                                    labelBg='#fff' 
                                    label={"Meter Number"} 
                                    id="meterNo" 
                                    type='text' 
                                    value={MeterNo} 
                                    onChange={(e) => setMeterNo(e.target.value)} 
                                />
                                
                                <Button 
                                    isLoading={Loading} 
                                    onClick={handleBtn} 
                                    background="#CF173C" 
                                    size="lg"
                                    h="56px"
                                >
                                    Search Meter
                                </Button>
                            </VStack>

                            {ErrorMSG.status && (
                                <Text mt={4} color="red.500" fontSize="sm" fontWeight="500">{ErrorMSG.msg}</Text>
                            )}

                            <Divider my={8} />

                            <VStack align="start" spacing={3} textAlign="left">
                                <Text fontWeight="700" fontSize="sm" color="gray.700">Tips to load your purchased energy token:</Text>
                                <HStack align="start" spacing={2}>
                                    <Icon as={FaCheckCircle} color="green.400" mt={1} />
                                    <Text fontSize="xs" color="gray.600">Ensure you have your meter number ready.</Text>
                                </HStack>
                                <HStack align="start" spacing={2}>
                                    <Icon as={FaCheckCircle} color="green.400" mt={1} />
                                    <Text fontSize="xs" color="gray.600">Input KCTs one after the other in sequence.</Text>
                                </HStack>
                            </VStack>
                        </Box>
                    </ScaleFade>
                ) : (
                    <ScaleFade initialScale={0.9} in={View === "result"}>
                        <VStack spacing={8} w={["100%", "100%", "800px"]} pb={10}>
                            {/* Result Header */}
                            <Flex w="100%" justify="space-between" align="center" bg="white" p={6} borderRadius="xl" boxShadow="sm">
                                <HStack spacing={4}>
                                    <Box as="button" onClick={handleBack} p={2} borderRadius="md" _hover={{ bg: "gray.100" }}>
                                        <FaArrowLeft />
                                    </Box>
                                    <VStack align="start" spacing={0}>
                                        <Text fontSize="sm" fontWeight="bold" color="gray.500">METER NUMBER</Text>
                                        <Text fontSize="xl" fontWeight="800" color="#01022E">{Data?.meterNo}</Text>
                                    </VStack>
                                </HStack>
                                <Badge colorScheme="green" p={2} borderRadius="md" variant="subtle">
                                    MIGRATION READY
                                </Badge>
                            </Flex>

                            {/* Actions */}
                            <Flex direction={["column", "row"]} gap={6} w="100%">
                                <VStack flex={1} spacing={6} align="stretch">
                                    <InstructionCard 
                                        title="Action 1: Set Tariff"
                                        icon={MeterIcon}
                                        tokens={Data.setTariffTokens}
                                        description="Load these tokens first to prepare your meter for the migration."
                                        colorScheme="blue"
                                    />
                                    
                                    <Box bg="orange.50" p={6} borderRadius="xl" border="1px dashed" borderColor="orange.200">
                                        <HStack mb={2}>
                                            <Icon as={MeterIcon} color="orange.500" />
                                            <Text fontWeight="700" color="orange.800">Action 2: Load Energy Token</Text>
                                        </HStack>
                                        <Text fontSize="sm" color="orange.700">Load the Energy Token(s) you recently purchased into your meter before proceeding to the <Box as="span" fontWeight="bold">ACTION 3.</Box></Text>
                                    </Box>
                                </VStack>

                                <VStack flex={1} spacing={6} align="stretch">
                                    <InstructionCard 
                                        title="Action 3: Revert Tariff"
                                        icon={FaHistory}
                                        tokens={Data.revertTariffTokens}
                                        description="finalize your operations by entering the revert tarrif token"
                                        colorScheme="purple"
                                    />

                                    <Box bg="#01022E" p={6} borderRadius="xl" color="white" boxShadow="xl">
                                        <Text fontSize="sm" fontWeight="600" mb={2}>Need help?</Text>
                                        <Text fontSize="xs" color="whiteAlpha.700" mb={4}>If you encounter any issues during the upgrade process, please contact us.</Text>
                                        <VStack align="start" spacing={1}>
                                            <Text fontSize="xs" fontWeight="bold">Email: customercare@ekedp.com</Text>
                                            {/* <Text fontSize="xs" fontWeight="bold">Phone: 0708 067 1170</Text> */}
                                        </VStack>
                                    </Box>
                                </VStack>
                            </Flex>
                        </VStack>
                    </ScaleFade>
                )}
            </Flex>
        </Box>
    )
}

